import { Form } from "@/contents/sanityTypes"
import { invokePushLead } from "@/features/crm/api/contacts"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import CustomFormController from "@/modules/forms/components/CustomFormController"

export interface SanityFormProps {
  content: Form[]
}

const SanityForm = ({ content }: SanityFormProps) => {
  const form = content[0]
  return (
    <CustomFormController
      definition={{
        name: form.name,
        fields:
          form.fields?.map((field: any) => ({
            name: field.name,
            label: field.contents?.label ?? field.name,
            type: field.type,
            defaultValue: field.defaultValue,
            placeholder: field.contents?.placeholder,
            required: field.required ?? false,
            colSpan: field.colspan ?? 1,
            messages: {
              formatError: (
                <SanityRichTextField
                  value={field.messages?.wrong_format_message}
                />
              ),
              requiredError: (
                <SanityRichTextField value={field.messages?.required_message} />
              ),
            },
          })) ?? [],
        cta: {
          label: <SanityRichTextField value={form.cta?.[0]?.label} />,
        },
        messages: {
          success: {
            illustration: (
              <SanityImageField
                asset={form.completedContents?.completedIcon}
                width={100}
                height={100}
              />
            ),
            message: (
              <SanityRichTextField
                value={form.completedContents?.completedMessage}
              />
            ),
            title: form.completedContents?.completedTitle,
            // (
            //   <SbRichTextField
            //     value={form.completedContents?.completedTitle ?? ""}
            //   />
            // ),
          },
        },
        submitAction: async (data) => {
          await invokePushLead(data as any)
        },
      }}
      gridColumns={form.columns}
    />
  )
}

export default SanityForm
